import { useReadContract } from "wagmi";
import { ArbitrageAbi, contractAddresses } from "../../../../meta";
import { DisplayValue, Typography } from "../../../../shared";
import { formatUnits } from "viem";

export const DisplayMaxMintBurnPriceDiff: React.FC = () => {
  const { data: maxMintBurnPriceDiff, ...rest } = useReadContract({
    abi: ArbitrageAbi,
    address: contractAddresses.Arbitrage,
    functionName: "maxMintBurnPriceDiff",
  });

  return (
    <div className="flex flex-row gap-2">
      <Typography>Max Mint Burn Price Diff:</Typography>
      <DisplayValue
        viewValue={formatUnits(BigInt(maxMintBurnPriceDiff || 0), 8)}
        {...rest}
      />
    </div>
  );
};
